export default __webpack_public_path__ + "static/us-dcbdc5662241788f9ad742639ad325d1.svg";